export default {
    getAppConfig: state => state.config.filter(c => c.use == "app"),
    getAdmConfig: state => state.config.filter(c => c.use == "adm"),
    getConfig: state => state.config
}